
import React from 'react';
import { createRoot } from 'react-dom/client';
import DispositionsSelector from './DispositionsSelector';

export default function DispositionsSelectorRoot(props) {
    return <DispositionsSelector {...props} />
}

if(typeof window.DispositionsSelectorRoots == 'undefined') {
    window.DispositionsSelectorRoots = {};
}

// MOUNT/UNMOUNT OK
window.DispositionsSelectorRoot = function (sectionTag = 'global') {
    const elements = document.querySelectorAll('[data-react="dispositions-selector"]');
    elements.forEach(element => {
        const uniqueId = element.dataset.windowId || sectionTag;
        
        if (window.DispositionsSelectorRoots[uniqueId] && window.DispositionsSelectorRoots[uniqueId].unmount) {
            window.DispositionsSelectorRoots[uniqueId].unmount();
        }

        let attr = {
            sectionTag: sectionTag,
            windowId: uniqueId
        };

        attr.name = element.getAttribute('name');
        element.removeAttribute('name');
        attr.defaultValue = (element.dataset.defaultValue && element.dataset.defaultValue != '') ? element.dataset.defaultValue : null;
        attr.ajax_load = element.dataset.ajaxLoad === 'false' ? false : true;
        attr.dispositions_loaded = JSON.parse(element.dataset.dispositionsLoaded ?? '[]');

        const root = createRoot(element);
        root.render(<DispositionsSelectorRoot {...attr} />);
        
        window.DispositionsSelectorRoots[uniqueId] = root;
    });
};